export interface IApplicationDto {
  appId: string | null;
  appName: string | null;
}

export class ApplicationDto implements IApplicationDto {
  public appId: string | null;
  public appName: string | null;

  constructor(appId: string | null, appName: string | null) {
    this.appId = appId;
    this.appName = appName;
  }
}
